<template>
  <div id="page">
    <NavBar />
    <main>
      <div class="container margin_60_35">
        <div class="row">
          <div class="col-sm-12 col-md-12 col-lg-12">
            <h5 class="nomargin_top">
              {{ $t('lang.forms.terms_and_conditions_link') }} - WeKeep Argentina
            </h5>
            <p class="mb-1">
              {{ $t('lang.tyc.tyc_arg_sub') }}
            </p>
            <div
              id="tyc_cyg"
              role="tablist"
              class="add_bottom_45 accordion_2"
            >
              <div class="card">
                <div class="card-body">
                  <iframe
                    style="width: 100%; height: 60vh"
                    src="/terms-conditions.pdf"
                  />
                </div>
              </div>
            </div>

            <h5 class="nomargin_top">
              {{ $t('lang.forms.terms_and_conditions_link') }} - WeKeep Travel Services LLC
            </h5>
            <p class="mb-1">
              {{ $t('lang.tyc.tyc_llc_sub') }}
            </p>
            <div
              id="tyc_llc"
              role="tablist"
              class="add_bottom_45 accordion_2"
            >
              <div class="card">
                <div class="card-body">
                  <iframe
                    style="width: 100%; height: 60vh"
                    src="/terms-conditions-llc.pdf"
                  />
                </div>
              </div>
            </div>

            <h5 class="nomargin_top">
              {{ $t('lang.forms.privacy_policy_link') }} - WeKeep Argentina
            </h5>
            <p class="mb-1">
              {{ $t('lang.tyc.pp_arg_sub') }}
            </p>
            <div
              id="privacy_cyg"
              role="tablist"
              class="add_bottom_45 accordion_2"
            >
              <div class="card">
                <div class="card-body">
                  <iframe
                    style="width: 100%; height: 60vh"
                    src="/privacy-policy.pdf"
                  />
                </div>
              </div>
            </div>

            <h5 class="nomargin_top">
              {{ $t('lang.forms.privacy_policy_link') }} - WeKeep Travel Services LLC
            </h5>
            <p class="mb-1">
              {{ $t('lang.tyc.pp_llc_sub') }}
            </p>
            <div
              id="privacy_llc"
              role="tablist"
              class="add_bottom_45 accordion_2"
            >
              <div class="card">
                <div class="card-body">
                  <iframe
                    style="width: 100%; height: 60vh"
                    src="/privacy-policy-llc.pdf"
                  />
                </div>
              </div>
            </div>

            <h5 class="nomargin_top">
              {{ $t('lang.home.prices.insurance_cond') }}
            </h5>
            <div
              id="insurance"
              role="tablist"
              class="add_bottom_45 accordion_2"
            >
              <div class="card">
                <div class="card-body">
                  <iframe
                    style="width: 100%; height: 60vh"
                    src="/insurance.pdf"
                  />
                </div>
              </div>
            </div>

            <!-- /accordion claim -->
          </div>

          <!-- /col -->
        </div>
        <!-- /row -->
      </div>
      <!--/container-->
    </main>

    <FooterComponent />
  </div>
</template>

<script>

import NavBar from '../components/NavBar/NavBar';
import FooterComponent from '../components/FooterComponent';

export default {
  name: 'TermsAndConditions',

  components: {
    NavBar,
    FooterComponent,
  },

  mounted() {
    switch (this.$route.hash) {
      case '#privacy':
        this.$scrollTo('#privacy_cyg', { offset: -130 });

        break;
      case '#insurance':
        this.$scrollTo('#insurance', { offset: -130 });
        break;
      case '':
      default:
        break;
    }
  },

};
</script>

<style scoped>

</style>
